import HTTP from '../../../../api/AxiosConfig';

export const getPartnersPage = (pageRequest) =>
    HTTP.post('/partner/partners-page', pageRequest);

export const createNewPartner = (partner) =>
    HTTP.post('/partner/new-partner', partner);

export const updatePartner = (record) =>
    HTTP.put('/partner', record);

export const deletePartner = (id) =>
    HTTP.delete('/partner?id=' + id);

export const savePartnerContracts = (request) =>
    HTTP.post('/partner/save-contracts', request);

export const getSoonExpiredContracts = () =>
    HTTP.get('/partner/soon-expired-contracts');
